import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { IListRequest } from "interfaces/list-duck";

import { requestErrorHandler } from "utils";
import { ListUnidadesActions } from "store/ducks/unidades";

export function* ListUnidadesRequest(action: any) {
  try {
    const { query = { state: "RJ" }, onSuccess } = action as IListRequest;
    const url = `/unidades/estado/${query.state}/${query?.lineo}`;
    console.log("VALOR DE URL: ", url);
    const { data } = yield call(api.get, url);
    const units = query.cidade
      ? data.filter(
          (unit: { Cidade: string; UF: string }) =>
            unit.Cidade?.trim().toUpperCase() ===
              query.cidade.trim().toUpperCase() &&
            unit.UF?.trim().toUpperCase() === query.state.trim().toUpperCase()
        )
      : data;

    yield put(ListUnidadesActions.success(units));
    if (onSuccess) onSuccess(units);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListUnidadesActions.failure(errorMessage));
  }
}
